import { createSlice } from "@reduxjs/toolkit";

const initialPersonnelType = {
  name: "",
  definition: ""
};

const initialPersonnelTypesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  authorities: null,
  personnelType: initialPersonnelType
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const personnelTypeSlice = createSlice({
  name: "personnelTypes",
  initialState: initialPersonnelTypesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPersonnelTypes
    personnelTypesFetched: (state, action) => {
      const { isSuccess, type, totalCount, allIds, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.allIds = allIds;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getPersonnelType
    personnelTypeFetched: (state, action) => {
      state.actionsLoading = false;      
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.personnelType = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanPersonnelTypesState
    personnelTypesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.personnelType = initialPersonnelType;
    }
  }
});